import {DeviceType} from 'ngx-device-detector';

import {signal, Signal} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {environment} from '../environments';
import {LanguageType} from '../shared-types';
import {MainInjector} from './index';

import IGlobals = Globals.IGlobals;

export class Globals implements IGlobals {
	deviceType: Signal<DeviceType> = signal(environment.deviceType);
	language: Signal<LanguageType> = signal(undefined);
	isMobile: Signal<boolean> = signal(environment.deviceType === DeviceType.Mobile);
	isTablet: Signal<boolean> = signal(environment.deviceType === DeviceType.Tablet);
	isDesktop: Signal<boolean> = signal(environment.deviceType === DeviceType.Desktop);

	constructor(window: Window) {
		window.translate = this.translate;
		window.deviceType = this.deviceType;
		window.isMobile = this.isMobile;
		window.isTablet = this.isTablet;
		window.isDesktop = this.isDesktop;
		window.language = this.language;
	}

	translate(key: string, params?: Record<string, any>, translateParams?: boolean): string {
		const translateService: TranslateService = MainInjector.get(TranslateService);
		if (translateParams) {
			params = Object.keys(params).reduce((acc, key) => {
				acc[key] = translateService.instant(params[key]);
				return acc;
			}, {});
		}
		return translateService.instant(key, params);
	}
}

new Globals(window);
